// Initializes the free shipping bar rendered on the product page (below the
// Add-to-Cart button). The cart drawer, quick cart, and purchase confirmation
// popup already initialize their own instances internally in theme.js -
// this covers the product page instance, which none of those handle, and
// keeps it in sync via the "cart:updated" custom event (requires
// `useCustomEvents` to be enabled in theme-globals.liquid).

(function () {
  if (window.__productFreeShippingBarInit) return;
  window.__productFreeShippingBarInit = true;

  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  // Same implementation Shopify ships in theme-scripts/theme-currency,
  // duplicated here so this file has no dependency on theme.js/theme.min.js.
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getNode() {
    return document.querySelector('.product-form [data-free-shipping-bar]');
  }

  // Mirrors the calculation in theme.js's freeShippingBar() exactly, so the
  // product page bar matches the cart drawer/quick cart bar pixel-for-pixel.
  function updateFreeShippingBar(node, cartTotal) {
    if (!node) return;

    var threshold = parseInt(node.dataset.threshold, 10);
    var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    threshold = Math.round(threshold * rate);
    var thresholdInCents = threshold * 100;

    node.dataset.cartTotal = cartTotal;

    var message = node.querySelector('.free-shipping-bar__message');
    var progressBar = node.querySelector('.free-shipping-bar__bar');

    if (cartTotal >= thresholdInCents) {
      node.classList.add('free-shipping-bar--success');
      if (message) message.innerText = node.dataset.freeShippingSuccessMessage;
    } else {
      node.classList.remove('free-shipping-bar--success');
      var remainder = Math.abs(cartTotal - thresholdInCents);
      if (message) {
        message.innerHTML = node.dataset.freeShippingPendingMessage.replace(
          '{{ remaining_amount }}',
          '<span class="fs-body-bold">' + formatMoney(remainder) + '</span>'
        );
      }
    }

    if (progressBar) {
      var progress = cartTotal < thresholdInCents ? cartTotal / threshold : 100;
      progressBar.style.setProperty('--progress-width', progress + '%');
    }

    node.classList.add('free-shipping-bar--loaded');
  }

  function init() {
    var node = getNode();
    if (!node) return;
    updateFreeShippingBar(node, parseInt(node.dataset.cartTotal, 10) || 0);
  }

  // Exposed so code that swaps in a fresh (unrendered) copy of this bar
  // without a full page load - e.g. the CU-869e2du2r sibling colour-switch
  // AJAX refresh in theme.js - can re-run this file's own render logic
  // against the new node, instead of duplicating the calculation elsewhere.
  window.updateProductFreeShippingBar = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:updated', function (evt) {
    if (!evt.detail || !evt.detail.cart) return;
    updateFreeShippingBar(getNode(), evt.detail.cart.total_price);
  });
})();
